const GRID_DETAIL_PANEL_TOGGLE_FIELD = "__detail_panel_toggle__";
export {
  GRID_DETAIL_PANEL_TOGGLE_FIELD
};
//# sourceMappingURL=gridDetailPanelToggleField.es.js.map
